import React from 'react';

const BookingSuccess = () => {
    return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6">
            <div className="bg-white rounded-2xl shadow-xl p-12 max-w-lg text-center">
                <div className="text-6xl mb-6">🎉</div>
                <h1 className="text-3xl font-bold text-slate-900 mb-4">Plată reușită!</h1>
                <p className="text-lg text-slate-600 mb-6">
                    Ședința ta a fost confirmată. Vei primi un email cu toate detaliile.
                </p>

                <a href="/"
                className="inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold px-8 py-3 rounded-xl transition shadow-md"
                >
                Înapoi la pagina principală
            </a>
        </div>
        </div>
    );
};

export default BookingSuccess;